var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.68675 13.3034C3.60865 13.3815 3.48201 13.3815 3.40391 13.3034L2.6968 12.5963C2.6187 12.5182 2.6187 12.3915 2.6968 12.3134L7.01012 8.00009L2.69676 3.68673C2.61866 3.60863 2.61866 3.48199 2.69676 3.40389L3.40387 2.69678C3.48197 2.61868 3.60861 2.61868 3.68671 2.69678L8.00007 7.01014L12.3135 2.69676C12.3916 2.61866 12.5182 2.61866 12.5963 2.69676L13.3034 3.40387C13.3815 3.48197 13.3815 3.60861 13.3034 3.68671L8.99002 8.00009L13.3034 12.3134C13.3815 12.3915 13.3815 12.5182 13.3034 12.5963L12.5963 13.3034C12.5182 13.3815 12.3915 13.3815 12.3134 13.3034L8.00007 8.99004L3.68675 13.3034Z",
    fill: "#070A26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.156a25e836d618a98da049c245c2050f.svg";
export { ForwardRef as ReactComponent };